import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import Variables from "../styles/variables.scss";
const SVG = ({ width, height, fillColor }) => (_jsxs("svg", { width: width, height: height, viewBox: "0 0 12 12", version: "1.1", children: [_jsx("title", { children: "+" }), _jsx("defs", {}), _jsx("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "square", children: _jsxs("g", { id: "icon/pluss", fillRule: "nonzero", stroke: fillColor, strokeWidth: "1", children: [_jsx("path", { d: "M6,1 L6,11", id: "Line-4" }), _jsx("path", { d: "M1,6 L11,6", id: "Line-4-Copy" })] }) })] }));
SVG.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fillColor: PropTypes.string,
};
SVG.defaultProps = {
    width: "20px",
    height: "20px",
    fillColor: Variables.blackPrimary,
};
export default SVG;
